import useAsync from "../hooks/useAsync"
import useSiteLanguage from "../hooks/useSiteLanguage"
import { UserOrders } from "../storeApi"

// Coin packs / gift cards / subscriptions are not "orders" on the old site (User/orders.jsx).
// The server answers only with catalog products (user {orders} looks each line up in the
// catalog), so this is a guard on the store product's own kind — never on its pid, which
// for a catalog product is its title's slug ("bitcoin-...").
const STORE_CREDIT_TYPES = ["coins", "subscription", "gift-card"]
export const isStoreCreditItem = (item) => STORE_CREDIT_TYPES.includes(item.type) || STORE_CREDIT_TYPES.includes(item.category)

/** The user's completed orders (user {orders}) for the account sections. */
export default function useOrders(enabled = true) {
  const language = useSiteLanguage()
  const { result, pending, error, refresh } = useAsync(() => UserOrders(language), [language, enabled], { enabled })
  const orders = result?.result
    ? (result.orders || [])
        .map((order) => ({ ...order, items: (order.items || []).filter((item) => !isStoreCreditItem(item)) }))
        // an order given back in full has no items left, and is still an order the buyer made
        .filter((order) => order.items.length > 0 || order.refunds?.length > 0)
    : []
  return { orders, pending: pending && !result, error: error || (result?.error ? new Error(result.error) : null), refresh }
}

// what a line is: the product's profile, beside it on the line (user {orders})
export const isLicenseKeyItem = (item) => !!item.profile?.license
// a download: files on the line, or a profile that sells one (the player's
// content — the library — opens in place, not here)
export const isDigitalItem = (item) => !isLicenseKeyItem(item) && (item.deliverables?.length > 0 || !!item.profile?.download)
export const hasDeliverables = (item) => item.deliverables?.length > 0
/** Orders whose every item is a download — shown with the "Digital" status */
export const isDigitalOnlyOrder = (order) => order.items.length > 0 && order.items.every(hasDeliverables)
export const hasLicenseKeys = (order) => order.items.some(isLicenseKeyItem) || (order.metadata && Object.keys(order.metadata).some((k) => k.startsWith("plk_")))
